/* Provider geometry and cart grouping; no network or credentials. */
(() => {
  const formats = {A4:[210,297],'30x40':[300,400],'40x60':[400,600],'50x70':[500,700]};
  function geometry(width,height,format,orientation) {
    if (!formats[format] || !['portrait','landscape'].includes(orientation)) throw new Error('INVALID_FORMAT');
    const [mmWidth,mmHeight] = formats[format];
    const rotated = orientation === 'landscape';
    const artWidth = rotated ? height : width, artHeight = rotated ? width : height;
    const bleedX = Math.max(1,Math.round(artWidth*4/mmWidth));
    const bleedY = Math.max(1,Math.round(artHeight*4/mmHeight));
    return {artWidth,artHeight,bleedX,bleedY,width:artWidth+2*bleedX,height:artHeight+2*bleedY,rotation:rotated?90:0};
  }
  function renderProvider(source,format,orientation,createCanvas=()=>document.createElement('canvas')) {
    const g=geometry(source.width,source.height,format,orientation);
    const art=createCanvas();art.width=g.artWidth;art.height=g.artHeight;
    const a=art.getContext('2d');if(!a)throw new Error('CANVAS_UNAVAILABLE');
    if(g.rotation){a.translate(g.artWidth,0);a.rotate(Math.PI/2);}a.drawImage(source,0,0);
    const canvas=createCanvas();canvas.width=g.width;canvas.height=g.height;
    const c=canvas.getContext('2d');if(!c)throw new Error('CANVAS_UNAVAILABLE');
    const {artWidth:w,artHeight:h,bleedX:x,bleedY:y}=g;
    // Keep the entire confirmed crop at its original pixel dimensions.
    c.drawImage(art,x,y);
    c.drawImage(art,0,0,1,h,0,y,x,h);c.drawImage(art,w-1,0,1,h,x+w,y,x,h);
    c.drawImage(art,0,0,w,1,x,0,w,y);c.drawImage(art,0,h-1,w,1,x,y+h,w,y);
    c.drawImage(art,0,0,1,1,0,0,x,y);c.drawImage(art,w-1,0,1,1,x+w,0,x,y);
    c.drawImage(art,0,h-1,1,1,0,y+h,x,y);c.drawImage(art,w-1,h-1,1,1,x+w,y+h,x,y);
    art.width=art.height=1;
    return {canvas,geometry:g};
  }
  window.MPGelatoCore={geometry,renderProvider};
})();
